const capFirstLetter = (val) => val.charAt(0).toUpperCase() + val.slice(1);
const getProp = (object, keys, defaultVal) => {
  if (typeof keys === 'undefined' || typeof object === 'undefined') {
    return defaultVal;
  }
  keys = Array.isArray(keys) ? keys : keys.split('.');
  object = object[keys[0]];
  if (object && keys.length > 1) {
    return getProp(object, keys.slice(1));
  }
  return object === undefined ? defaultVal : object;
}
const forEach = (data, callback) => {
  if (typeof callback !== 'function') {
    // eslint-disable-next-line no-console
    console.error('callback must be a function');
  }
  if (typeof data === 'object') {
    for (const [key, value] of Object.entries(data)) {
      callback(value, key);
    }
  } else {
    callback(data);
  }
}
const dateFormat = (local = 'en-US', type = 'default') => {
  const options = {
    monthLong: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    reviewFormat: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    blogFormat: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    default: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
  return new Intl.DateTimeFormat(local, (type && options[type]) || {})
}

export default {
  capFirstLetter,
  getProp,
  forEach,
  dateFormat
};